import { uniqueId } from "lodash";
import { Link } from "react-router-dom";
import useJStyles from "$hooks/useJStyles";

interface TableRow {
  label: string;
  value: string | React.ReactNode;
  link?: string;
  linkState?: Record<string, unknown>;
  isDisabled?: boolean;
}

interface InformationTableProps {
  rows: TableRow[];
}

export default function InformationTable({ rows }: InformationTableProps) {
  const { jclasses } = useJStyles();

  return (
    <table>
      {rows.map((row) => (
        <tr key={uniqueId()}>
          <td className="label">{row.label}</td>
          <td className={row.isDisabled ? "disabled" : "data"}>
            {row.link ? (
              <Link
                to={
                  row.linkState
                    ? { pathname: row.link, state: row.linkState }
                    : row.link
                }
                className={jclasses?.ghostLink}
              >
                {row.value}
              </Link>
            ) : (
              row.value
            )}
          </td>
        </tr>
      ))}
    </table>
  );
}
